import { Component, inject } from '@angular/core';
import { StopCompensationTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StopCompensationTypeCreateDto,
  StopCompensationTypeDto,
  StopCompensationTypeExcelDownloadDto,
  StopCompensationTypeUpdateDto,
} from '../proxy/controlling/dtos/stop-compensation-type';
import { STOPCOMPENSATIONTYPE_CONFIG, STOPCOMPENSATIONTYPE_FIELDS } from './stop-compensation-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stop-compensation-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StopCompensationTypeService, ConfirmationService],
  templateUrl: './stop-compensation-type.html',
  styleUrl: './stop-compensation-type.scss',
})
export class StopCompensationType extends BaseCrudComponent<
  StopCompensationTypeDto,
  StopCompensationTypeCreateDto,
  StopCompensationTypeUpdateDto,
  StopCompensationTypeExcelDownloadDto
> {
  service = inject(StopCompensationTypeService);
  config = STOPCOMPENSATIONTYPE_CONFIG;
  fields = STOPCOMPENSATIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: StopCompensationTypeDto): StopCompensationTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StopCompensationType';
  }
}
